import { config, IJsonRpcResponse } from "../api";

interface IRefundResponse extends IJsonRpcResponse {
    result: {
        success: boolean;
        message: string;
    }
}

export interface IInvoiceItemRefundRequest {
    invoiceItemID: number;
    amount: number;
}

export const issueRefund = async (
    customerID: number,
    invoiceID: number,
    invoiceItemRefunds: IInvoiceItemRefundRequest[],
    note: string
) => {
    const params = {
        invoiceItemRefunds,
        customerID,
        invoiceID,
        note
    };
    const authToken = config.authToken;
    const res = await fetch(`${config.url}/issueRefund`, {
        body: JSON.stringify(params),
        headers: {
            'Authorization': 'Bearer ' + authToken,
            'Content-Type': 'application/json'
        },
        method: 'post',
        mode: 'cors'
    });
    if (!res.ok) {
        throw new Error('Backend request failed.');
    }
    const body: IRefundResponse = await res.json();
    return body.result;
};
